/* eslint-disable */

import React from "react";
import Header from "./header";
import Section from "./section";

function TriangleQuiz() {
  return (
    <div className="section">
      <Header />
      <Section />
    </div>
  );
}

export default TriangleQuiz;
